"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../data/model");
var utils_1 = require("../data/utils");
var commands_1 = require("../diagram/commands");
var elements_1 = require("../diagram/elements");
var geometry_1 = require("../diagram/geometry");
var history_1 = require("../diagram/history");
var paperArea_1 = require("../diagram/paperArea");
var events_1 = require("../viewUtils/events");
var dialog_1 = require("../widgets/dialog");
var connectionsMenu_1 = require("../widgets/connectionsMenu");
var editEntityForm_1 = require("../widgets/editEntityForm");
var editElementTypeForm_1 = require("../widgets/editElementTypeForm");
var editLinkForm_1 = require("../widgets/editLinkForm");
var halo_1 = require("../widgets/halo");
var haloLink_1 = require("../widgets/haloLink");
var statesWidget_1 = require("./statesWidget");
var layout_1 = require("../viewUtils/layout");
var spinner_1 = require("../viewUtils/spinner");
var asyncModel_1 = require("./asyncModel");
var authoringState_1 = require("./authoringState");
var editLayer_1 = require("./editLayer");
var async_1 = require("../viewUtils/async");
var DialogTypes;
(function (DialogTypes) {
    DialogTypes[DialogTypes["ConnectionsMenu"] = 0] = "ConnectionsMenu";
    DialogTypes[DialogTypes["EditEntityForm"] = 1] = "EditEntityForm";
    DialogTypes[DialogTypes["EditLinkForm"] = 2] = "EditLinkForm";
    DialogTypes[DialogTypes["EditEntityTypeForm"] = 3] = "EditEntityTypeForm";
})(DialogTypes = exports.DialogTypes || (exports.DialogTypes = {}));
var EditorController = /** @class */ (function () {
    function EditorController(props) {
        var _this = this;
        this.listener = new events_1.EventObserver();
        this.source = new events_1.EventSource();
        this.events = this.source;
        this._authoringState = authoringState_1.AuthoringState.empty;
        this._validationState = authoringState_1.ValidationState.empty;
        this._temporaryState = authoringState_1.TemporaryState.empty;
        this._selection = [];
        this.cancellation = new async_1.Cancellation();
        this.onKeyUp = function (e) {
            var DELETE_KEY_CODE = 46;
            if (e.keyCode === DELETE_KEY_CODE &&
                document.activeElement.localName !== 'input') {
                _this.removeSelectedElements();
            }
        };
        var model = props.model, view = props.view, options = tslib_1.__rest(props, ["model", "view"]);
        this.model = model;
        this.view = view;
        this.options = options;
        this.listener.listen(this.events, 'changeValidationState', function (e) {
            for (var _i = 0, _a = _this.model.elements; _i < _a.length; _i++) {
                var element = _a[_i];
                var previous = e.previous.elements.get(element.iri);
                var current = _this.validationState.elements.get(element.iri);
                if (current !== previous) {
                    element.redraw();
                }
            }
        });
    }
    EditorController.prototype._initializePaperComponents = function (paperArea) {
        var _this = this;
        this.listener.listen(paperArea.events, 'pointerUp', function (e) { return _this.onPaperPointerUp(e); });
        this.listener.listen(this.model.events, 'changeCells', function () { return _this.onCellsChanged(); });
        this.listener.listen(this.model.events, 'elementEvent', function (e) {
            if (e.key === 'requestedGroupContent') {
                _this.loadGroupContent(e.data.requestedGroupContent.source);
            }
        });
        this.listener.listen(this.model.events, 'loadingStart', function () { return _this.setSpinner({}); });
        this.listener.listen(this.model.events, 'loadingSuccess', function () {
            _this.setSpinner(undefined);
            var widget = React.createElement(statesWidget_1.StatesWidget, { editor: _this, view: _this.view });
            _this.view.setPaperWidget({ key: 'states', widget: widget });
        });
        this.listener.listen(this.model.events, 'loadingError', function (_a) {
            var error = _a.error;
            var statusText = error ? error.message : undefined;
            _this.setSpinner({ statusText: statusText, errorOccured: true });
        });
        if (!this.options.disableHalo) {
            this.configureHalo();
            document.addEventListener('keyup', this.onKeyUp);
            this.listener.listen(this.view.events, 'dispose', function () {
                document.removeEventListener('keyup', _this.onKeyUp);
            });
        }
    };
    Object.defineProperty(EditorController.prototype, "inAuthoringMode", {
        get: function () {
            return Boolean(this._metadataApi);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EditorController.prototype, "metadataApi", {
        get: function () { return this._metadataApi; },
        enumerable: true,
        configurable: true
    });
    EditorController.prototype.setMetadataApi = function (value) {
        var previous = this._metadataApi;
        if (value === previous) {
            return;
        }
        this._metadataApi = value;
        if (Boolean(value) !== Boolean(previous)) {
            // authoring mode changed
            this.source.trigger('changeMode', { source: this });
        }
    };
    Object.defineProperty(EditorController.prototype, "authoringState", {
        get: function () { return this._authoringState; },
        enumerable: true,
        configurable: true
    });
    EditorController.prototype.setAuthoringState = function (value) {
        var previous = this._authoringState;
        if (previous === value) {
            return;
        }
        this.model.history.execute(this.updateAuthoringState(value));
    };
    EditorController.prototype.updateAuthoringState = function (state) {
        var _this = this;
        var previous = this._authoringState;
        return history_1.Command.create('Create or delete entities and links', function () {
            _this._authoringState = state;
            _this.source.trigger('changeAuthoringState', { source: _this, previous: previous });
            return _this.updateAuthoringState(previous);
        });
    };
    Object.defineProperty(EditorController.prototype, "validationState", {
        get: function () { return this._validationState; },
        enumerable: true,
        configurable: true
    });
    EditorController.prototype.setValidationState = function (value) {
        var previous = this._validationState;
        if (value === previous) {
            return;
        }
        this._validationState = value;
        this.source.trigger('changeValidationState', { source: this, previous: previous });
    };
    Object.defineProperty(EditorController.prototype, "temporaryState", {
        get: function () { return this._temporaryState; },
        enumerable: true,
        configurable: true
    });
    EditorController.prototype.setTemporaryState = function (value) {
        var previous = this._temporaryState;
        if (value === previous) {
            return;
        }
        this._temporaryState = value;
        this.source.trigger('changeTemporaryState', { source: this, previous: previous });
    };
    Object.defineProperty(EditorController.prototype, "selection", {
        get: function () { return this._selection; },
        enumerable: true,
        configurable: true
    });
    EditorController.prototype.setSelection = function (value) {
        var previous = this._selection;
        if (previous === value) {
            return;
        }
        this._selection = value;
        this.source.trigger('changeSelection', { source: this, previous: previous });
    };
    EditorController.prototype.cancelSelection = function () {
        this.setSelection([]);
    };
    EditorController.prototype.removeSelectedElements = function () {
        var itemsToRemove = this.selection;
        if (itemsToRemove.length === 0) {
            return;
        }
        this.cancelSelection();
        this.removeItems(itemsToRemove);
    };
    EditorController.prototype.removeItems = function (items) {
        var state = this.authoringState;
        var batch = this.model.history.startBatch();
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item instanceof elements_1.Element) {
                if (authoringState_1.AuthoringState.isNewElement(state, item.iri)) {
                    this.deleteEntity(item.iri);
                }
                else {
                    this.model.removeElement(item.id);
                }
            }
            else if (item instanceof elements_1.Link) {
                if (authoringState_1.AuthoringState.isNewLink(state, item.data)) {
                    this.deleteLink(item.data);
                }
            }
        }
        batch.store();
    };
    EditorController.prototype.onPaperPointerUp = function (event) {
        if (this.options.disableHalo) {
            return;
        }
        var sourceEvent = event.sourceEvent, target = event.target, triggerAsClick = event.triggerAsClick;
        if (sourceEvent.ctrlKey || sourceEvent.shiftKey || sourceEvent.metaKey) {
            return;
        }
        if (target instanceof elements_1.Element) {
            this.setSelection([target]);
            target.focus();
        }
        else if (target instanceof elements_1.Link) {
            this.setSelection([target]);
        }
        else if (target instanceof elements_1.LinkVertex) {
            this.setSelection([target.link]);
        }
        else if (!target && triggerAsClick) {
            this.setSelection([]);
            this.hideDialog();
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }
    };
    EditorController.prototype.onCellsChanged = function () {
        var _this = this;
        if (this.selection.length === 0) {
            return;
        }
        var newSelection = this.selection.filter(function (el) { return _this.model.getElement(el.id); });
        if (newSelection.length < this.selection.length) {
            this.setSelection(newSelection);
        }
    };
    EditorController.prototype.setSpinner = function (props) {
        var widget = props ? React.createElement(LoadingWidget, { spinnerProps: props }) : undefined;
        this.view.setPaperWidget({ key: LoadingWidget.Key, widget: widget, pinnedToScreen: true });
    };
    EditorController.prototype.configureHalo = function () {
        var _this = this;
        if (this.options.disableHalo) {
            return;
        }
        this.listener.listen(this.events, 'changeSelection', function () {
            var selected = _this.selection.length === 1 ? _this.selection[0] : undefined;
            if (_this.dialogTarget && selected !== _this.dialogTarget) {
                _this.hideDialog();
                _this.resetTemporaryState();
            }
            _this.renderDefaultHalo();
        });
        this.listener.listen(this.events, 'toggleDialog', function (_a) {
            var isOpened = _a.isOpened;
            _this.renderDefaultHalo();
        });
        this.renderDefaultHalo();
    };
    EditorController.prototype.renderDefaultHalo = function () {
        var _this = this;
        var selected = this.selection.length === 1 ? this.selection[0] : undefined;
        var halo;
        if (selected instanceof elements_1.Element) {
            halo = (React.createElement(halo_1.Halo, { editor: this, metadataApi: this.metadataApi, target: selected, onRemove: function () { return _this.removeSelectedElements(); }, onExpand: function () {
                    _this.model.history.execute(commands_1.setElementExpanded(selected, !selected.isExpanded));
                }, navigationMenuOpened: this.dialogType === DialogTypes.ConnectionsMenu, onToggleNavigationMenu: function () {
                    if (_this.dialogTarget && _this.dialogType === DialogTypes.ConnectionsMenu) {
                        _this.hideDialog();
                    }
                    else {
                        _this.showConnectionsMenu(selected);
                    }
                    _this.renderDefaultHalo();
                }, onAddToFilter: function () { return selected.addToFilter(); }, onEstablishNewLink: function (point) {
                    return _this.startEditing({ target: selected, mode: editLayer_1.EditLayerMode.establishLink, point: point });
                } }));
        }
        else if (selected instanceof elements_1.Link && this.inAuthoringMode) {
            halo = (React.createElement(haloLink_1.HaloLink, { view: this.view, editor: this, metadataApi: this.metadataApi, target: selected, onEdit: function () { return _this.showEditLinkForm(selected); }, onDelete: function () { return _this.deleteLink(selected.data); }, onRevert: function () {
                    var deletion = _this.authoringState.index.links.get(selected.data);
                    if (deletion && deletion.type === authoringState_1.AuthoringKind.DeleteLink) {
                        _this.discardChange(deletion);
                    }
                }, onSourceMove: function (point) {
                    return _this.startEditing({ target: selected, mode: editLayer_1.EditLayerMode.moveLinkSource, point: point });
                }, onTargetMove: function (point) {
                    return _this.startEditing({ target: selected, mode: editLayer_1.EditLayerMode.moveLinkTarget, point: point });
                } }));
        }
        this.view.setPaperWidget({ key: 'halo', widget: halo });
    };
    EditorController.prototype.showConnectionsMenu = function (target) {
        var _this = this;
        var dialogType = DialogTypes.ConnectionsMenu;
        var content = (React.createElement(connectionsMenu_1.ConnectionsMenu, { view: this.view, editor: this, target: target, onClose: function () { return _this.hideDialog(); }, suggestProperties: this.options.suggestProperties }));
        this.showDialog({ target: target, dialogType: dialogType, content: content });
    };
    EditorController.prototype.showEditEntityForm = function (target) {
        var _this = this;
        var propertyEditor = this.options.propertyEditor;
        var dialogType = DialogTypes.EditEntityForm;
        var onSubmit = function (newData) {
            _this.hideDialog();
            _this.changeEntityData(newData.id, newData);
        };
        var content = propertyEditor ? propertyEditor({ elementData: target.data, onSubmit: onSubmit }) : (React.createElement(editEntityForm_1.EditEntityForm, { view: this.view, entity: target.data, onApply: onSubmit, onCancel: function () { return _this.hideDialog(); } }));
        this.showDialog({ target: target, dialogType: dialogType, content: content });
    };
    EditorController.prototype.showEditElementTypeForm = function (params) {
        var _this = this;
        var link = params.link, source = params.source, target = params.target;
        var dialogType = DialogTypes.EditEntityTypeForm;
        var content = (React.createElement(editElementTypeForm_1.EditElementTypeForm, { view: this.view, metadataApi: this.metadataApi, link: link.data, source: source.data, target: target.data, onApply: function (elementData, linkData) {
                if (_this.temporaryState.elements.has(target.iri)) {
                    target.setData(elementData);
                    _this.setTemporaryState(authoringState_1.TemporaryState.deleteElement(_this.temporaryState, target.data));
                    _this.addNewEntity(target.data);
                }
                else {
                    _this.changeEntityData(target.iri, elementData);
                }
                if (_this.temporaryState.links.has(link.data)) {
                    _this.removeTemporaryLink(link);
                    _this.createNewLink(new elements_1.Link({
                        typeId: linkData.linkTypeId,
                        sourceId: link.sourceId,
                        targetId: link.targetId,
                        data: linkData,
                    }));
                }
                else {
                    _this.changeLink(link.data, linkData);
                }
                _this.hideDialog();
            }, onCancel: function () {
                if (_this.temporaryState.elements.has(target.iri)) {
                    _this.removeTemporaryElement(target);
                }
                if (_this.temporaryState.links.has(link.data)) {
                    _this.removeTemporaryLink(link);
                }
                _this.hideDialog();
            } }));
        this.showDialog({ target: target, dialogType: dialogType, content: content });
    };
    EditorController.prototype.showEditLinkForm = function (target) {
        var _this = this;
        var dialogType = DialogTypes.EditLinkForm;
        var content = (React.createElement(editLinkForm_1.EditLinkForm, { view: this.view, metadataApi: this.metadataApi, link: target, onApply: function (data) {
                if (_this.temporaryState.links.has(target.data)) {
                    _this.removeTemporaryLink(target);
                    _this.createNewLink(new elements_1.Link({
                        typeId: data.linkTypeId,
                        sourceId: target.sourceId,
                        targetId: target.targetId,
                        data: data,
                    }));
                }
                else {
                    _this.changeLink(target.data, data);
                }
                _this.hideDialog();
            }, onCancel: function () {
                if (_this.temporaryState.links.has(target.data)) {
                    _this.removeTemporaryLink(target);
                }
                _this.hideDialog();
            } }));
        this.showDialog({ target: target, dialogType: dialogType, content: content });
    };
    EditorController.prototype.showDialog = function (params) {
        var target = params.target, dialogType = params.dialogType, content = params.content;
        this.dialogTarget = target;
        this.dialogType = dialogType;
        var dialog = (React.createElement(dialog_1.Dialog, { view: this.view, target: target }, content));
        this.view.setPaperWidget({ key: 'dialog', widget: dialog });
        this.source.trigger('toggleDialog', { isOpened: false });
    };
    EditorController.prototype.hideDialog = function () {
        if (this.dialogTarget) {
            this.dialogType = undefined;
            this.dialogTarget = undefined;
            this.view.setPaperWidget({ key: 'dialog', widget: undefined });
            this.source.trigger('toggleDialog', { isOpened: false });
        }
    };
    EditorController.prototype.onDragDrop = function (e, paperPosition) {
        e.preventDefault();
        var elementIris;
        try {
            elementIris = JSON.parse(e.dataTransfer.getData('application/x-ontodia-elements'));
        }
        catch (ex) {
            try {
                elementIris = JSON.parse(e.dataTransfer.getData('text')); // IE fix
            }
            catch (ex) {
                var draggedUri = e.dataTransfer.getData('text/uri-list');
                // element dragged from the class tree has URI of the form:
                // <window.location without hash>#<class URI>
                var uriFromTreePrefix = window.location.href.split('#')[0] + '#';
                var uri = draggedUri.indexOf(uriFromTreePrefix) === 0
                    ? draggedUri.substring(uriFromTreePrefix.length) : draggedUri;
                elementIris = [uri];
            }
        }
        if (!elementIris || elementIris.length === 0) {
            return;
        }
        var batch = this.model.history.startBatch('Drag and drop onto diagram');
        var placedElements = placeElements(this.view, elementIris, paperPosition);
        batch.history.execute(asyncModel_1.restoreLinksBetweenElements(this.model, elementIris));
        batch.store();
        if (placedElements.length > 0) {
            placedElements[placedElements.length - 1].focus();
        }
        this.setSelection(placedElements);
    };
    EditorController.prototype.loadGroupContent = function (element) {
        var _this = this;
        return this.model.loadEmbeddedElements(element.iri).then(function (models) {
            var batch = _this.model.history.startBatch();
            var elementIris = Object.keys(models);
            var elements = elementIris.map(function (key) { return _this.model.createElement(models[key], element.id); });
            batch.discard();
            return Promise.all([
                _this.model.requestElementData(elementIris),
                _this.model.requestLinksOfType(),
            ]).then(function () {
                _this.view.performSyncUpdate();
                var grouping = geometry_1.computeGrouping(_this.model.elements);
                recursiveForceLayout(_this.model, grouping, element.id);
                _this.model.triggerChangeGroupContent(element.id);
            });
        });
    };
    EditorController.prototype.createNewEntity = function (classIri) {
        var batch = this.model.history.startBatch('Create new entity');
        var elementModel = {
            // TODO: change IRI generation
            id: "http://ontodia.org/newEntity_" + utils_1.generate64BitID(),
            types: [classIri],
            label: { values: [{ text: 'New Entity', lang: '' }] },
            properties: {},
        };
        var element = this.model.createElement(elementModel);
        element.setExpanded(true);
        if (editLayer_1.isPlaceholderElementType(classIri)) {
            this.setTemporaryState(authoringState_1.TemporaryState.addElement(this.temporaryState, element.data));
            batch.discard();
        }
        else {
            this.setAuthoringState(authoringState_1.AuthoringState.addElement(this._authoringState, element.data));
            batch.store();
        }
        return element;
    };
    EditorController.prototype.changeEntityData = function (targetIri, newData) {
        var elements = this.model.elements.filter(function (el) { return el.iri === targetIri; });
        if (elements.length === 0) {
            return;
        }
        var oldData = elements[0].data;
        var batch = this.model.history.startBatch('Edit entity');
        this.model.history.execute(commands_1.setElementData(this.model, targetIri, newData));
        this.setAuthoringState(authoringState_1.AuthoringState.changeElement(this._authoringState, oldData, newData));
        batch.store();
    };
    EditorController.prototype.deleteEntity = function (elementIri) {
        var state = this.authoringState;
        var elements = this.model.elements.filter(function (el) { return el.iri === elementIri; });
        if (elements.length === 0) {
            return;
        }
        var batch = this.model.history.startBatch('Delete entity');
        var model = elements[0].data;
        var event = state.index.elements.get(elementIri);
        if (event && event.type === authoringState_1.AuthoringKind.ChangeElement) {
            if (event.before) {
                // restore initial data
                this.model.history.execute(commands_1.setElementData(this.model, elementIri, event.before));
            }
            else {
                // delete newly created entity
                for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
                    var element = elements_2[_i];
                    this.model.removeElement(element.id);
                }
            }
        }
        var newlyConnectedLinks = this.model.links.filter(function (link) {
            if (!link.data) {
                return false;
            }
            return authoringState_1.isLinkConnectedToElement(link.data, elementIri)
                && authoringState_1.AuthoringState.isNewLink(state, link.data);
        });
        for (var _a = 0, newlyConnectedLinks_1 = newlyConnectedLinks; _a < newlyConnectedLinks_1.length; _a++) {
            var link = newlyConnectedLinks_1[_a];
            this.model.removeLink(link.id);
        }
        this.setAuthoringState(authoringState_1.AuthoringState.deleteElement(state, model));
        batch.store();
    };
    EditorController.prototype.createNewLink = function (base) {
        var batch = this.model.history.startBatch('Create new link');
        this.model.createLinks(base.data);
        var links = this.model.links.filter(function (link) { return model_1.sameLink(link.data, base.data); });
        if (links.length > 0) {
            if (editLayer_1.isPlaceholderLinkType(base.typeId)) {
                this.setTemporaryState(authoringState_1.TemporaryState.addLink(this.temporaryState, base.data));
                batch.discard();
            }
            else {
                this.setAuthoringState(authoringState_1.AuthoringState.addLink(this._authoringState, base.data));
                batch.store();
            }
        }
        else {
            batch.discard();
        }
        return links.find(function (_a) {
            var sourceId = _a.sourceId, targetId = _a.targetId;
            return sourceId === base.sourceId && targetId === base.targetId;
        });
    };
    EditorController.prototype.changeLink = function (oldData, newData) {
        var _this = this;
        var batch = this.model.history.startBatch('Change link');
        if (model_1.sameLink(oldData, newData)) {
            this.model.history.execute(commands_1.setLinkData(this.model, oldData, newData));
            this.setAuthoringState(authoringState_1.AuthoringState.changeLink(this._authoringState, oldData, newData));
        }
        else {
            var newState = this._authoringState;
            newState = authoringState_1.AuthoringState.deleteLink(newState, oldData);
            newState = authoringState_1.AuthoringState.addLink(newState, newData);
            if (authoringState_1.AuthoringState.isNewLink(this._authoringState, oldData)) {
                this.model.links
                    .filter(function (link) { return model_1.sameLink(link.data, oldData); })
                    .forEach(function (link) { return _this.model.removeLink(link.id); });
            }
            this.model.createLinks(newData);
            this.setAuthoringState(newState);
        }
        batch.store();
    };
    EditorController.prototype.moveLinkSource = function (params) {
        var link = params.link, newSource = params.newSource;
        var batch = this.model.history.startBatch('Move link to another element');
        this.changeLink(link.data, tslib_1.__assign({}, link.data, { sourceId: newSource.iri }));
        var newLink = this.model.findLink(link.typeId, newSource.id, link.targetId);
        newLink.setVertices(link.vertices);
        batch.store();
        return newLink;
    };
    EditorController.prototype.moveLinkTarget = function (params) {
        var link = params.link, newTarget = params.newTarget;
        var batch = this.model.history.startBatch('Move link to another element');
        this.changeLink(link.data, tslib_1.__assign({}, link.data, { targetId: newTarget.iri }));
        var newLink = this.model.findLink(link.typeId, link.sourceId, newTarget.id);
        newLink.setVertices(link.vertices);
        batch.store();
        return newLink;
    };
    EditorController.prototype.deleteLink = function (model) {
        var _this = this;
        var state = this.authoringState;
        var event = state.index.links.get(model);
        if (event && event.type === authoringState_1.AuthoringKind.DeleteLink) {
            return;
        }
        var batch = this.model.history.startBatch('Delete link');
        var newState = authoringState_1.AuthoringState.deleteLink(state, model);
        if (authoringState_1.AuthoringState.isNewLink(state, model)) {
            this.model.links
                .filter(function (_a) {
                var data = _a.data;
                return model_1.sameLink(data, model);
            })
                .forEach(function (link) { return _this.model.removeLink(link.id); });
        }
        this.setAuthoringState(newState);
        batch.store();
    };
    EditorController.prototype.startEditing = function (params) {
        var target = params.target, mode = params.mode, point = params.point;
        var editLayer = (React.createElement(editLayer_1.EditLayer, { view: this.view, editor: this, metadataApi: this.metadataApi, mode: mode, target: target, point: point }));
        this.view.setPaperWidget({ key: 'editLayer', widget: editLayer });
    };
    EditorController.prototype.finishEditing = function () {
        this.view.setPaperWidget({ key: 'editLayer', widget: undefined });
    };
    EditorController.prototype.validateChangedSince = function (previousAuthoring) {
        var _this = this;
        var validationApi = this.options.validationApi;
        if (!validationApi) {
            return;
        }
        var previousValidation = this.validationState;
        var currentAuthoring = this.authoringState;
        var newState = authoringState_1.ValidationState.createMutable();
        var hasChangedLinks = new Set();
        for (var _i = 0, _a = this.model.links; _i < _a.length; _i++) {
            var data = _a[_i].data;
            var current = currentAuthoring.index.links.get(data);
            var previous = previousAuthoring.index.links.get(data);
            var state = previousValidation.links.get(data);
            if (current !== previous) {
                hasChangedLinks.add(data.sourceId);
                newState.links.set(data, tslib_1.__assign({}, authoringState_1.ValidationState.emptyLink, state, { loading: true }));
            }
            else if (state) {
                newState.links.set(data, state);
            }
        }
        var _loop_1 = function (element) {
            if (newState.elements.has(element.iri)) {
                return "continue";
            }
            var current = currentAuthoring.index.elements.get(element.iri);
            var previous = previousAuthoring.index.elements.get(element.iri);
            var state = previousValidation.elements.get(element.iri);
            if (hasChangedLinks.has(element.iri) || current !== previous) {
                var loadingState_1 = tslib_1.__assign({}, authoringState_1.ValidationState.emptyElement, state, { loading: true });
                newState.elements.set(element.iri, loadingState_1);
                validationApi.validateElement(element.data, currentAuthoring, this_1.cancellation.signal).then(function (loadedErrors) {
                    var stateAfterLoad = _this.validationState.elements.get(element.iri);
                    if (stateAfterLoad !== loadingState_1) {
                        return;
                    }
                    var validation = authoringState_1.ValidationState.setElementErrors(_this.validationState, element.iri, loadedErrors);
                    _this.setValidationState(validation);
                });
            }
            else if (state) {
                newState.elements.set(element.iri, state);
            }
        };
        var this_1 = this;
        for (var _b = 0, _c = this.model.elements; _b < _c.length; _b++) {
            var element = _c[_b];
            _loop_1(element);
        }
        this.setValidationState(newState);
    };
    EditorController.prototype.addNewEntity = function (element) {
        var batch = this.model.history.startBatch('Create new entity');
        this.setAuthoringState(authoringState_1.AuthoringState.addElement(this._authoringState, element));
        batch.store();
    };
    EditorController.prototype.resetTemporaryState = function () {
        var _this = this;
        if (this.temporaryState.elements.size) {
            this.model.elements.forEach(function (element) {
                if (_this.temporaryState.elements.has(element.iri)) {
                    _this.removeTemporaryElement(element);
                }
            });
        }
        if (this.temporaryState.links.size) {
            this.model.links.forEach(function (link) {
                if (_this.temporaryState.links.get(link.data)) {
                    _this.removeTemporaryLink(link);
                }
            });
        }
    };
    EditorController.prototype.removeTemporaryElement = function (element) {
        this.model.removeElement(element.id);
        this.setTemporaryState(authoringState_1.TemporaryState.deleteElement(this.temporaryState, element.data));
    };
    EditorController.prototype.removeTemporaryLink = function (link) {
        this.model.removeLink(link.id);
        this.setTemporaryState(authoringState_1.TemporaryState.deleteLink(this.temporaryState, link.data));
    };
    EditorController.prototype.discardChange = function (event) {
        var _this = this;
        var newState = authoringState_1.AuthoringState.discard(this._authoringState, event);
        if (newState === this._authoringState) {
            return;
        }
        var batch = this.model.history.startBatch('Discard change');
        if (event.type === authoringState_1.AuthoringKind.ChangeElement) {
            if (event.before) {
                this.model.history.execute(commands_1.setElementData(this.model, event.after.id, event.before));
            }
            else {
                this.model.elements
                    .filter(function (el) { return el.iri === event.after.id; })
                    .forEach(function (el) { return _this.model.removeElement(el.id); });
            }
        }
        else if (event.type === authoringState_1.AuthoringKind.ChangeLink) {
            if (event.before) {
                this.model.history.execute(commands_1.setLinkData(this.model, event.after, event.before));
            }
            else {
                this.model.links
                    .filter(function (_a) {
                    var data = _a.data;
                    return model_1.sameLink(data, event.after);
                })
                    .forEach(function (link) { return _this.model.removeLink(link.id); });
            }
        }
        this.setAuthoringState(newState);
        batch.store();
    };
    return EditorController;
}());
exports.EditorController = EditorController;
var LoadingWidget = /** @class */ (function (_super) {
    tslib_1.__extends(LoadingWidget, _super);
    function LoadingWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingWidget.prototype.render = function () {
        var _a = this.props, spinnerProps = _a.spinnerProps, paperArea = _a.paperArea;
        var areaMetrics = paperArea.getAreaMetrics();
        var paneWidth = areaMetrics.clientWidth;
        var paneHeight = areaMetrics.clientHeight;
        var x = spinnerProps.statusText ? paneWidth / 3 : paneWidth / 2;
        var position = { x: x, y: paneHeight / 2 };
        return (React.createElement("div", { className: 'ontodia-loading-widget' },
            React.createElement("svg", { width: paneWidth, height: paneHeight },
                React.createElement(spinner_1.Spinner, tslib_1.__assign({ position: position }, spinnerProps)))));
    };
    LoadingWidget.Key = 'loadingWidget';
    return LoadingWidget;
}(React.Component));
function placeElements(view, elementIris, position) {
    var elements = elementIris.map(function (iri) { return view.model.createElement(iri); });
    view.performSyncUpdate();
    var x = position.x, y = position.y;
    var isFirst = true;
    for (var _i = 0, elements_3 = elements; _i < elements_3.length; _i++) {
        var element = elements_3[_i];
        var _a = geometry_1.boundsOf(element), width = _a.width, height = _a.height;
        if (width === 0) {
            width = 100;
        }
        if (height === 0) {
            height = 50;
        }
        if (isFirst) {
            isFirst = false;
            x -= width / 2;
            y -= height / 2;
        }
        element.setPosition({ x: x, y: y });
        y += height + 20;
    }
    return elements;
}
function recursiveForceLayout(model, grouping, group) {
    var elements = group
        ? grouping.get(group)
        : model.elements.filter(function (el) { return el.group === undefined; });
    for (var _i = 0, elements_4 = elements; _i < elements_4.length; _i++) {
        var element = elements_4[_i];
        if (grouping.has(element.id)) {
            recursiveForceLayout(model, grouping, element.id);
        }
    }
    var nodes = [];
    var nodeById = {};
    for (var _a = 0, elements_5 = elements; _a < elements_5.length; _a++) {
        var element = elements_5[_a];
        var _b = geometry_1.boundsOf(element), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        var node = { id: element.id, x: x, y: y, width: width, height: height };
        nodeById[element.id] = node;
        nodes.push(node);
    }
    var links = [];
    for (var _c = 0, _d = model.links; _c < _d.length; _c++) {
        var link = _d[_c];
        if (!model.isSourceAndTargetVisible(link)) {
            continue;
        }
        var source = model.sourceOf(link);
        var target = model.targetOf(link);
        var sourceNode = nodeById[source.id];
        var targetNode = nodeById[target.id];
        if (sourceNode && targetNode) {
            links.push({ source: sourceNode, target: targetNode });
        }
    }
    layout_1.forceLayout({ nodes: nodes, links: links, preferredLinkLength: 200 });
    layout_1.padded(nodes, { x: 50, y: 50 }, function () { return layout_1.removeOverlaps(nodes); });
    var padding = group ? paperArea_1.getContentFittingBox(elements, []) : { x: 150, y: 150 };
    layout_1.translateToPositiveQuadrant({ nodes: nodes, padding: padding });
    for (var _e = 0, nodes_1 = nodes; _e < nodes_1.length; _e++) {
        var node = nodes_1[_e];
        var element = model.getElement(node.id);
        element.setPosition({ x: node.x, y: node.y });
    }
}
exports.recursiveForceLayout = recursiveForceLayout;
